import { useRef } from 'react';
export default function useCustomRef() {
    var myRef = useRef(null);
    return { ref: myRef };
}
